export default __webpack_public_path__ + "static/media/edit.971fbd0e.svg";